import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import posthog from 'posthog-js'
import { FiChevronLeft } from 'react-icons/fi'
import { getMyGuarantees } from 'services/guarantees'
import { faPlain, toman } from 'utilities/helper/format'
import { PulseCard } from 'components/states'

/**
 * «ضمانت‌های شما» — standing behind someone else's loan is a liability the
 * member carries personally, so it belongs on their home screen rather than
 * inside any one fund.
 *
 * Hidden entirely when they guarantee nothing, which today is almost everyone:
 * the ضامن feature has only just shipped. This section cannot move a launch
 * metric yet and should not be judged on engagement.
 *
 * Two things are deliberately NOT shown here:
 *  - `delinquency_rate`, which is normalised against the fund's worst
 *    guarantor and therefore always reads 100 for somebody.
 *  - inferred guarantees. `get_guarantor_graph` will infer an edge for
 *    reporting, but telling a person they are liable for a debt they never
 *    accepted is a different thing entirely.
 */
export default function GuaranteesCard() {
    const navigate = useNavigate()
    const { data, isLoading } = useQuery(['my-guarantees'], getMyGuarantees, {
        staleTime: 60_000,
    })

    if (isLoading) return <PulseCard />
    // Silent on error: a guarantee card that fails to load is not worth an
    // error box on a screen whose primary job is elsewhere.
    if (!data?.summary?.active_count) return null

    const { summary } = data

    return (
        <button
            type="button"
            onClick={() => {
                posthog.capture('guarantees_opened', { source: 'home' })
                navigate('/guarantees')
            }}
            className="w-full text-right bg-white border border-divider rounded-card p-4 cursor-pointer"
        >
            <div className="flex items-center justify-between">
                <p className="text-base font-bold text-heading">
                    ضمانت‌های شما
                </p>
                <FiChevronLeft className="text-text-muted shrink-0" />
            </div>
            <p className="mt-1 text-sm text-text-body text-right">
                {faPlain.format(summary.active_count)} وام ·{' '}
                {toman(summary.outstanding_amount)} در جریان
            </p>
            {summary.overdue_count > 0 && (
                <div className="mt-3 bg-danger-soft text-danger-on rounded-lg px-3 py-2 text-xs font-bold text-right">
                    {faPlain.format(summary.overdue_count)} وام در تاخیر —{' '}
                    {toman(summary.overdue_amount)}
                </div>
            )}
        </button>
    )
}
